module.exports = __webpack_public_path__ + "61b337e3690e14d4115c8a7d6975ddb6.png";